import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import { Grid, Button, Card } from 'semantic-ui-react';

import { ClassProp } from 'helpers/types';

import styles from './Pagination.styles';

export type PageDetails = {
  nextPage: number;
  hasNextPage: boolean;
  pageSize: number;
};

type Props = {
  classes: ClassProp<typeof styles>;
  onLoadMore: any;
  pagination: PageDetails;
  currPage: number;
};

const Pagination: FunctionComponent<Props> = ({
  classes,
  onLoadMore,
  pagination,
}) => {
  const nextPage = pagination.nextPage;

  const loadMore = () => {
    onLoadMore(nextPage);
  };

  return (
    <Grid className={classes.searchGrid} columns="equal">
      <Grid.Row>
        <Card fluid className={classes.container}>
          <Card.Content className={classes.content}>
            <Button
              disabled={!pagination.hasNextPage}
              onClick={loadMore}
              className={classes.button}
              fluid
            >
              Load More {pagination.pageSize}
            </Button>
          </Card.Content>
        </Card>
      </Grid.Row>
    </Grid>
  );
};

export default withStyles(styles)(Pagination);
